<app-navbar></app-navbar>
<div  id="outage">
    <div *ngIf="outagebol" class="container" id="form">
      <div class="title">Logo Update</div>
      <div class="content">
        <form action="#" (submit)="preview($event)" >
          <div class="user-details">
              <div class="input-box">
                    <span class="details">Upload Enterprise Image</span>
                <input (change)="onFileChanged2($event)" class="image" type="file" value="Enterprise Image" id="submit-ei" />
              </div>
          </div>
          <div class="button">
            <input type="submit" value="Preview" id="submit" />
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="previewbol" class="container" id="preview">

      <h3>Enterprise Image</h3>
      <img class="images" src="{{previewImage2}}" alt="">


      <form action="#" (submit)="sendemail()">
        <div class="button">
          <input (click)="goback()" type="submit" value="Go Back" id="back" />
        </div>
        <div *ngIf="!loading"  class="button" >

          <input type="submit" value="Update Profile" id="send-email" />
        </div>
        <div *ngIf="!loading" class="button" >
          <input type="button" id="send-email" value = "Purge Profile" (click)="onnclickpurge()"/>
        </div>
        <div *ngIf="loading" class="loadingbtn">
          <button class="btn btn-primary button" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Updating Profile...
          </button>
        </div>
        <div id="outage-response" *ngIf="statusAvailable">
          <span>Status</span>
          {{returndata}}
          <span>{{responseMessage}}</span>
        </div>
      </form>
    </div>
  </div>
